import React, { useEffect, useState } from "react";
import { toggle } from "../../../../util/common";
import ManageAccountTab from "../../ManageAccountTab";
import * as ProtectionPlanActions from "../../../../store/protectionPlanService/ezs/actions";
import { useDispatch, useSelector } from "react-redux";
import EZSProtectionPlanDialogContainer from "./EZSProtectionPlanDialogContainer";
import NoActivePlan from "../NoActivePlan";
import parse from "html-react-parser";
import { ApplicationState } from "../../../../store";
import * as CSIDActions from "../../../../store/csid/actions";
import * as services from "../../../../store/service";
import ErrorBoundary from "../../../common/ErrorBoundary";
import { IPackage } from "../../../../store/protectionPlanService/ezs/types";
import { GET_ACCOUNT_INFORMATION_LOADER } from "../../../../store/myAccount/types";
import LogoContainer from "../../../common/LogoContainer";
import RenderIcons from "../../../../Assets/css/_icons/partner_icon/RenderIcons";
import * as LoginActions from "../../../../store/loginService/actions";
import { useTranslation } from "react-i18next";
import WhatYouNeedToKnow from "../../../common/WhatYouNeedToKnow";
import * as httpClient from "../../../../util/httpClient";
import { Notification } from "../../../common/Notification";

const EZSProtectionPlan: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const refreshCSIDUserStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus(true));
    const requestProtectionPlan = (forcefullyRefresh: boolean) => dispatch(ProtectionPlanActions.actionCreators.requestProtectionPlan(forcefullyRefresh));
    const protectionPlanSelector = useSelector((state: ApplicationState) => state.protectionPlanState);

    const SetLanguageChange = (updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.LanguageChange(updateUsersLang));

    // const preferencedLanguage = useSelector((state: ApplicationState) =>
    //     state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en");

    const hasLanguageChanged = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.hasLanguageChanged ? state.loggedInUser.userInfo?.hasLanguageChanged : false
    );

    const accountInfo = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState._unifiedAccountInfo : null));
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const updateServiceDetails = () => dispatch(LoginActions.actionCreators.updateSmbServiceDetails());
    const { t: tLang } = useTranslation();
    const [serviceListOfSelectedPackage, setServiceListOfSelectedPackage]: any = useState([""]);
    const isAvastId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2611
                ? true
                : false
            : false
    );
    const isAVGId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2659
                ? true
                : false
            : false
    );
    const isAVGTestId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2662
                ? true
                : false
            : false
    );
    const isBfsCyberscoutId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2564
                ? true
                : false
            : false
    );


    const [showCancelForBfsPartner, setShowCancelForBfsPartner] = useState(false);

    const [isUserHaveTrial, setIsUserHaveTrial] = useState(false);

    const [isTwoStepCancellation, setTwoStepCancellation] = useState(false);

    useEffect(() => {

        const packageList = protectionPlanSelector.protectionPlanData && protectionPlanSelector.protectionPlanData.packageList;

        if (packageList && packageList.length > 0) {
            let productNames = [] as string[];
            packageList.forEach((pkg) => {
                pkg.Products?.forEach((p) => {
                    if (p.name != null && p.name !== "" && p.name !== "--") {
                        productNames.push(p.name);
                    }
                });

                if (isUserHaveTrial === false) {
                    if (pkg.IsActive && pkg.IsPackageCancel && pkg.RemainingTrialDays > 0) {
                        setIsUserHaveTrial(true);
                    }
                }
                if (showCancelForBfsPartner === false) {
                    if (pkg.IsActive && isBfsCyberscoutId && pkg.PacakgeType == "5") {

                        setShowCancelForBfsPartner(true);
                    }
                }
            });
            setServiceListOfSelectedPackage(productNames);
        }
    }, [protectionPlanSelector]);

    useEffect(() => {
        if (accountInfo == null) {
            getAccountInformation();
        }
    }, [accountInfo]);

    useEffect(() => {
        if (accountInfo && accountInfo.isSSOUser) {
            services
                .getPackageUpdateForSSO()
                .then((res) => {
                    if (res.isPackageUpdatedForSSOUser) {
                        requestProtectionPlan(true);
                    } else {
                        requestProtectionPlan(false);
                    }
                })
                .catch((e) => {
                    requestProtectionPlan(false);
                });
        } else {
            if (hasLanguageChanged) {
                requestProtectionPlan(true);
                SetLanguageChange(false);
            } else requestProtectionPlan(false);
        }
        if (renderSiteInIFrame) {
            updateServiceDetails();
        }
        if (isAvastId) {
            document.title = tLang("manageAccount.protectionPlan.documentTitle");
        }
        if (isAVGId || isAVGTestId) {
            document.title = tLang("manageAccount.protectionPlan.documentTitle");
        }
    }, []);

    const getAccountInformation = () => {
        httpClient
            .sendRequest("GET", "api/accountInfo/getAccountInformation")
            .then((data) => {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
                if (data && data.hasError === false) {
                    dispatch({
                        type: "GET_ACCOUNT_INFORMATION",
                        _unifiedAccountInfo: data._unifiedAccountInfo,
                    });
                }
            })
            .catch(function (error) {
                dispatch({ type: GET_ACCOUNT_INFORMATION_LOADER, isLoading: false });
            });
    };

    const getTwoStepCancellationStates = () => {
        httpClient.sendRequest("GET", "api/accountInfo/getAccountInformation").then((accountInfodata) => {
            if (accountInfodata && accountInfodata.hasError === false) {
                const requestBody = {
                    TransactionType: "TWO-STEP-CANCEL",
                    PartnerID: null,
                    RetailerID: null,
                    CountryISO: accountInfodata._unifiedAccountInfo.country,
                    IsDisabled: false
                };
                services
                    .getTwoStepCancellationStates(requestBody)
                    .then((data) => {
                        if (!data["hasError"]) {
                            let isTwoStepCancellationState = data.twoStepCancellationStatesList.some((el: { stateCode: string | undefined; }) => el.stateCode === accountInfodata._unifiedAccountInfo.state)
                            if (isTwoStepCancellationState) {
                                setTwoStepCancellation(true);
                            }
                        }
                    }).catch((err) => {
                        Notification({
                            type: "error",
                            title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                            message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
                        });
                    });

            }
        }).catch((err) => {
            Notification({
                type: "error",
                title: tLang("manageAccount.protectionPlan.notification.errorTitle"),
                message: tLang("manageAccount.protectionPlan.notification.somethingWentWrongMsg"),
            });
        });
    };

    useEffect(() => {
        getTwoStepCancellationStates();
    }, []);

    const [isFirstPlan, setIsFirstPlan] = useState(true);
    const [confirmationDialog, setConfirmationDialog] = useState(false);
    const [changePackageIsActive, setConfirmChangePackageIsActive] = useState(false);
    const [initialDialog, setInitialDialog] = useState("");
    const [packageIndex, setPackageIndex] = useState(-1);
    const [subscriptionTypeChange, setSubscriptionTypeChange] = useState(false);

    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    const [adultMemberCount] = useState(
        familyMembers.filter((x) => x.accountType === "Family Plan Adult" || x.accountType === "Family Plan Young Adult")
            ? familyMembers.filter((x) => x.accountType === "Family Plan Adult" || x.accountType === "Family Plan Young Adult").length
            : []
    );

    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    const confirmChange = (index: number, initDialog: string) => {
        setPackageIndex(index);
        setInitialDialog(initDialog);
        setConfirmationDialog(true);
    };

    const confirmChangePackageIsActive = (isPackageActive: boolean) => {
        setConfirmChangePackageIsActive(isPackageActive);
    };

    const confirmChangeSubscription = (index: number, initDialog: string) => {
        setSubscriptionTypeChange(true);
        confirmChange(index, initDialog);
    };

    const closeProtectionPlanDialog = () => {
        setPackageIndex(-1);
        setInitialDialog("");
        refreshCSIDUserStatus();
        setSubscriptionTypeChange(false);
        setConfirmationDialog(false);
        setConfirmChangePackageIsActive(false);
    };

    const isDisplayNoActivePkgMsg = () => {
        if (protectionPlanSelector && protectionPlanSelector.protectionPlanData) {
            const packages = protectionPlanSelector.protectionPlanData.packageList;
            const activePackage = packages?.find((it) => it.IsActive);
            if (packages && packages.length > 0 && !activePackage) {
                return true;
            }
        }
        return false;
    };

    const showNextPlan = () => {
        var protectionPlanTable: any = document.getElementById("protection-table");
        if (protectionPlanTable != null) {
            var currentPlan = 0;
            let currentPlanText = protectionPlanTable.getAttribute("class") + "";
            currentPlan = parseInt(currentPlanText.substr(currentPlanText.length - 1));
            var tablePlans = protectionPlanTable.rows[0].cells.length;
            tablePlans = tablePlans - 1;

            if (tablePlans === currentPlan) {
                (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = true;
            } else {
                protectionPlanTable.classList.remove("show-plan-" + currentPlan);
                currentPlan++;
                protectionPlanTable.classList.add("show-plan-" + currentPlan);

                if (tablePlans === currentPlan) {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = true;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                } else {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                }
            }
            setIsFirstPlan(false);
        }
    };
    const showPrevPlan = () => {
        let protectionPlanTable: any = document.getElementById("protection-table");
        if (protectionPlanTable != null) {
            var currentPlan = 0;
            let currentPlanText = protectionPlanTable.getAttribute("class") + "";
            currentPlan = parseInt(currentPlanText.substr(currentPlanText.length - 1));
            var tablePlans = protectionPlanTable.rows[0].cells.length;
            tablePlans = tablePlans - 1;

            if (currentPlan === 1) {
                (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = true;
            } else {
                protectionPlanTable.classList.remove("show-plan-" + currentPlan);
                currentPlan--;
                protectionPlanTable.classList.add("show-plan-" + currentPlan);

                if (currentPlan === 1) {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = true;
                } else {
                    (document.getElementById("btn-next-plan") as HTMLButtonElement)!.disabled = false;
                    (document.getElementById("btn-prev-plan") as HTMLButtonElement)!.disabled = false;
                }
            }
        }
    };

    const displayProduct = (isActive: boolean, product: any) => {
        if (product.labelText === "==cross==") {
            return (
                <div className="plan-icon">
                    <em className="las la-times" title="Not included in Package"></em>{" "}
                    <span className="sr-only">{tLang("manageAccount.protectionPlan.notIncluded")}</span>
                </div>
            );
        } else if (product.labelText === "==tick==") {
            if (isActive && product.name === "SVC-FAMILY-SERVICE") {
                return adultMemberCount > 1
                    ? adultMemberCount + tLang("manageAccount.protectionPlan.adults")
                    : adultMemberCount + tLang("manageAccount.protectionPlan.adult");
            } else {
                return (
                    <div className="plan-icon">
                        <em className="las la-check-circle" title="Included in Package"></em>{" "}
                        <span className="sr-only">{tLang("manageAccount.protectionPlan.included")}</span>
                    </div>
                );
            }
        } else {
            return creditProvider === "DUNBRADSTREET" && product?.name.match(/SVC-BIZ-CREDIT/g) ? product?.displayName : product?.labelText;
        }
    };

    const showProductDetail = (detailDesc: string) => {
        if (detailDesc) {
            return parse(detailDesc?.replace("bulleted_list serviceDescription", "list-default list-condensed"));
        }
    };

    const showRow = (section: string) => {
        const packageList = protectionPlanSelector.protectionPlanData && protectionPlanSelector.protectionPlanData.packageList;
        let billingArr = [];
        let savingsArr = [];
        let providedArr = [];
        let showPrice = false;
        let showButton = false;
        let showTrialDays = false;

        if (packageList) {
            packageList.forEach((pkg) => {
                if (pkg.PartnerId === 493 && pkg.PackagId === 13573) {
                    pkg.DisplayPrice = false;
                }
                if (pkg.DisplayPrice) {
                    showPrice = true;
                }
                if (pkg.BillingText) {
                    billingArr.push(pkg.BillingText);
                }
                //US-23896-removing condition for commerce bank.
                if ((pkg.IsActive && showCancelForBfsPartner) || (pkg.IsActive && pkg.IsPackageCancel) || (!pkg.IsActive && (pkg.IsPacakgeUpgradable || (pkg.Price != null && pkg.Price === 0 && pkg.IsPSS)))) {
                    showButton = true;
                }
                if (pkg.ShowSubscriptionTypeChangeText) {
                    savingsArr.push(pkg.ShowSubscriptionTypeChangeText);
                }
                if (pkg.PartnerName) {
                    providedArr.push(pkg.PartnerName);
                }
                if (pkg.RemainingTrialDays && pkg.RemainingTrialDays !== 0) {
                    showTrialDays = true;
                }
            });
        }

        switch (section) {
            case "price":
                if (showPrice) {
                    return true;
                }
                break;
            case "cta":
                if (showButton) {
                    return true;
                }
                break;
            case "remaining-days":
                if (showTrialDays) {
                    return true;
                }
                break;
            case "billing":
                if (billingArr.length > 0) {
                    return true;
                }
                break;
            case "savings":
                if (savingsArr.length > 0) {
                    return true;
                }
                break;
            case "providedBy":
                if (providedArr.length > 0) {
                    return true;
                }
                break;
            default:
                return false;
        }
    };

    const renderSpacer = () => {
        return (
            <th className="row-label" scope="col">
                <div className="sr-only">{tLang("manageAccount.protectionPlan.feature")}</div>
            </th>
        );
    };

    const renderPackageHeaderRow = (section: string) => {
        return (
            <React.Fragment>
                {protectionPlanSelector.protectionPlanData &&
                    protectionPlanSelector.protectionPlanData.packageList &&
                    protectionPlanSelector.protectionPlanData.packageList.map((pkg, pkgIndex: number) => (
                        <th className="row-cell" scope="col" key={"pkg-detail-" + pkgIndex}>
                            <div className="plan-container">
                                {section === "title" ? (
                                    renderTitle(pkg)
                                ) : section === "price" ? (
                                    renderPrice(pkg)
                                ) : section === "cta" ? (
                                    renderButton(pkg, pkgIndex)
                                ) : section === "remaining-days" ? (
                                    renderRemainingDays(pkg)
                                ) : section === "billing" ? (
                                    renderBilling(pkg)
                                ) : section === "savings" && pkg.IsPacakgeUpgradable ? (
                                    renderSavings(pkg, pkgIndex)
                                ) : section === "providedBy" ? (
                                    renderProvidedBy(pkg)
                                ) : (
                                    <></>
                                )}
                            </div>
                        </th>
                    ))}
            </React.Fragment>
        );
    };

    const renderTitle = (pkg: IPackage) => {
        return (
            <div className="plan-title">
                {pkg.PackageName} {pkg.IsActive ? <span className="plan-current">{tLang("manageAccount.protectionPlan.current")}</span> : null}
            </div>
        );
    };

    const renderRemainingDays = (pkg: IPackage) => {
        return (
            <div className={pkg.IsActive && pkg.IsPackageCancel && pkg.RemainingTrialDays && pkg.RemainingTrialDays !== 0 ? "margin-bottom-s" : ""}>
                {pkg.IsActive && pkg.IsPackageCancel && pkg.RemainingTrialDays && pkg.RemainingTrialDays !== 0 ? (
                    <span> {pkg.RemainingTrialDays} day trial remaining </span>
                ) : (
                    <span></span>
                )}
            </div>
        );
    };

    const renderPrice = (pkg: IPackage) => {
        // resolved bug - 15624
        if (pkg.DisplayPrice) {
            if (pkg.ShowCrossOut && pkg.Price !== 0) {
                return (
                    <React.Fragment>
                        <span className="normal-text">${displayBasePriceAsCrossout(pkg)}</span>
                        {displayPackagePrice(pkg)}
                    </React.Fragment>
                );
            } else if (pkg.ShowCrossOut && pkg.Price === 0) {
                return (
                    <React.Fragment>
                        <div className="plan-price">
                            ${displayBasePriceAsCrossout(pkg)}
                            {displaySubscriptionTypeAbbr(pkg)}
                        </div>
                    </React.Fragment>
                );
            } else if (pkg.IsUserPaid && pkg.IsActive) {
                return displayPackagePrice(pkg);
            } else if (pkg.Price !== 0) {
                return displayPackagePrice(pkg);
            } else if (pkg.IsBusinessUser && !pkg.IsPSS && pkg.IsUserPaid) {
                // to solve bug: 18196
                return displayPackagePrice(pkg);
            } else if (!pkg.IsPSS && pkg.Price === 0) {
                return displayPackagePrice(pkg);
            }
        }
    };

    const displayBasePriceAsCrossout = (pkg: IPackage) => {
        return (
            <React.Fragment>
                {pkg.SubcriptionType?.toLowerCase() === "monthly" && <s>{Number(pkg.BasePackagePrice).toFixed(2)}</s>}
                {pkg.SubcriptionType?.toLowerCase() === "yearly" && <s>{Number(pkg.BasePackagePriceYearly).toFixed(2)}</s>}
            </React.Fragment>
        );
    };

    const displayPackagePrice = (pkg: IPackage) => {
        return (
            <React.Fragment>
                <div className="plan-price">
                    ${Number(pkg.Price).toFixed(2)}
                    {displaySubscriptionTypeAbbr(pkg)}
                </div>
            </React.Fragment>
        );
    };

    const displaySubscriptionTypeAbbr = (pkg: IPackage) => {
        return (
            <small>
                /{pkg.SubcriptionType?.toLowerCase() === "monthly" && <abbr title="Monthly">mo</abbr>}
                {pkg.SubcriptionType?.toLowerCase() === "yearly" && <abbr title="Yearly">yr</abbr>}
            </small>
        );
    };

    const renderButton = (pkg: IPackage, pkgIndex: number) => {
        if (pkg.IsActive && showCancelForBfsPartner) {
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-grey btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanCancellation");
                                confirmChangePackageIsActive(pkg.IsActive);
                            }}
                        >
                            <span className="btn-text">
                                {tLang("manageAccount.protectionPlan.btn.cancel")} <span className="sr-only">{pkg.PackageName}</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        } else if (pkg.IsActive && pkg.IsPackageCancel && pkg.ActionButtonText?.toUpperCase() === "CANCEL" && isTwoStepCancellation && pkg.RemainingTrialDays > 0) {
            /* One Step Cancellation for Trial Period*/
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-grey btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanTrialTwoStepCancellation");
                                confirmChangePackageIsActive(pkg.IsActive);
                                window.addToDataLayer({
                                    event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase()
                                });
                            }}
                        >
                            <span className="btn-text">
                                {tLang("manageAccount.protectionPlan.btn.cancel")} <span className="sr-only">{pkg.PackageName}
                                </span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        }
        else if (pkg.IsActive && pkg.IsPackageCancel && pkg.ActionButtonText?.toUpperCase() === "CANCEL" && isTwoStepCancellation) {
            /* One Step Cancellation for Non-Trial Period*/
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-grey btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanTwoStepCancellation");
                                confirmChangePackageIsActive(pkg.IsActive);
                                window.addToDataLayer({
                                    event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase()
                                });
                            }}
                        >
                            <span className="btn-text">
                                {tLang("manageAccount.protectionPlan.btn.cancel")} <span className="sr-only">{pkg.PackageName}
                                </span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        }
        // resolved BUG - 15305
        //US-23896-removing condition for commerce bank.  
        else if (pkg.IsActive && pkg.IsPackageCancel && pkg.RemainingTrialDays > 0) {
            /* Trial CANCEL */
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-grey btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanUpgradeConfirmation");
                                confirmChangePackageIsActive(pkg.IsActive);
                                window.addToDataLayer({ event: "Protection Plan - Trial " + pkg.ActionButtonText?.toUpperCase() });
                            }}
                        >
                            <span className="btn-text">
                                {tLang("manageAccount.protectionPlan.btn.cancel")}
                                <span className="sr-only">{pkg.PackageName}</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        } else if (pkg.IsActive && pkg.IsPackageCancel) {
            /* CANCEL */
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-grey btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanUpgradeConfirmation");
                                confirmChangePackageIsActive(pkg.IsActive);
                                window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                            }}
                        >
                            <span className="btn-text">
                                {tLang("manageAccount.protectionPlan.btn.cancel")} <span className="sr-only">{pkg.PackageName}</span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        } else if (!pkg.IsActive && (pkg.IsPacakgeUpgradable || (pkg.Price != null && pkg.Price === 0 && pkg.IsPSS))) {
            /* UPGRADE | DOWNGRADE */
            return (
                <React.Fragment>
                    <div className="plan-cta">
                        <button
                            type="button"
                            className="btn-default btn-primary btn-min-width"
                            onClick={() => {
                                confirmChange(pkgIndex, "ProtectionPlanUpgradeConfirmation");
                                confirmChangePackageIsActive(pkg.IsActive);
                                window.addToDataLayer({ event: "Protection Plan - " + pkg.ActionButtonText?.toUpperCase() });
                            }}
                        >
                            <span className="btn-text">
                                {pkg.ActionButtonText === "Downgrade"
                                    ? tLang("manageAccount.protectionPlan.btn.downgrade")
                                    : pkg.ActionButtonText === "Select"
                                        ? tLang("manageAccount.protectionPlan.btn.select")
                                        : pkg.ActionButtonText}{" "}
                                <span className="sr-only">
                                    {tLang("manageAccount.protectionPlan.toPlanName.text1")} {pkg.PackageName}{" "}
                                    {tLang("manageAccount.protectionPlan.toPlanName.text2")}
                                </span>
                            </span>
                        </button>
                    </div>
                </React.Fragment>
            );
        }
    };

    //Part-12063
    const renderBilling = (pkg: IPackage) => {
        if (pkg.PartnerId === 428 && pkg.ShowBillingText) {
            return (
                <React.Fragment>
                    <p className="space-reduction">
                        {pkg.BillingText}
                        <br />
                    </p>
                    <p>{tLang("manageAccount.protectionPlan.message.changeProtectionPlan")}</p>
                </React.Fragment>
            );
        } else if (pkg.ShowBillingText) {
            return (
                <p className="space-reduction">
                    {pkg.BillingText}
                    <br />
                    <br />
                </p>
            );
        }
    };

    const renderSavings = (pkg: IPackage, pkgIndex: number) => {
        if (pkg.ShowSubscriptionTypeChangeText) {
            return (
                <React.Fragment>
                    {pkg.SubcriptionType?.toLowerCase() === "monthly" && (pkg.PackagePriceYearly !== 0 || (!pkg.IsPSS && pkg.PackagePriceYearly === 0)) && (
                        <div className="plan-saving">
                            {pkg.YearlySavingPrice && (
                                <span
                                    className="plan-saving-percentage"
                                    onClick={() => {
                                        confirmChangeSubscription(pkgIndex, "ProtectionPlanSubscriptionChangeDialog");
                                        window.addToDataLayer({ event: "Protection Plan - Subscription Type Change" });
                                    }}
                                >
                                    {tLang("manageAccount.protectionPlan.saveyr.text1")} {" "}
                                    {tLang("manageAccount.protectionPlan.saveyr.text2")}
                                </span>
                            )}
                            <span className="plan-price-annual">
                                ${pkg.PackagePriceYearly?.toFixed(2)}/<abbr title="Yearly">yr</abbr>
                            </span>
                        </div>
                    )}

                    {pkg.SubcriptionType?.toLowerCase() === "yearly" && (pkg.PackagePrice !== 0 || (!pkg.IsPSS && pkg.PackagePrice === 0)) && (
                        <div className="plan-saving">
                            <span
                                className="plan-saving-percentage"
                                onClick={() => {
                                    confirmChangeSubscription(pkgIndex, "ProtectionPlanSubscriptionChangeDialog");
                                    window.addToDataLayer({ event: "Protection Plan - Subscription Type Change" });
                                }}
                            >
                                {tLang("manageAccount.protectionPlan.monthlySubscription")}
                            </span>
                            <span className="plan-price-annual">
                                ${pkg.PackagePrice?.toFixed(2)}/<abbr title="Monthly">mo</abbr>
                            </span>
                        </div>
                    )}
                </React.Fragment>
            );
        }
    };

    const renderProvidedBy = (pkg: IPackage) => {
        if (pkg.PartnerName) {
            return (
                <React.Fragment>
                    <p>{pkg.ProvidedBy}</p>
                    <strong>{pkg.PartnerName}</strong>
                </React.Fragment>
            );
        }
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12 row">
                    <h1 className="title-page" id="ez-protection-plan-page" tabIndex={-1}>
                        {(isAvastId || isAVGId || isAVGTestId) ? "Manage Profile" : tLang("manageAccount.title")}
                    </h1>
                    <LogoContainer internalPage={true} />
                </div>
            </div>

            <ManageAccountTab selectedTab="2" isAvastId={isAvastId || isAVGId || isAVGTestId} />

            <div className="row" id="protection-plan-content">
                <div className="col-xs">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <RenderIcons iconName="cube" />
                                </div>
                                <div className="box-title-text">
                                    <h2 className="box-title">{tLang("manageAccount.protectionPlan.tabTitle")}</h2>
                                </div>
                            </div>
                            <WhatYouNeedToKnow serviceList={serviceListOfSelectedPackage} selectedCountry={accountInfo?.country} />
                            {!protectionPlanSelector?.isLoading &&
                                protectionPlanSelector?.protectionPlanData &&
                                protectionPlanSelector?.protectionPlanData?.packageList &&
                                protectionPlanSelector?.protectionPlanData?.packageList?.length < 1 && <NoActivePlan partnerPhoneNumber={partnerPhoneNumber} />}
                        </div>

                        {protectionPlanSelector == null || protectionPlanSelector.isLoading ? (
                            <div className="box loading"></div>
                        ) : (
                            <React.Fragment>
                                {!isDisplayNoActivePkgMsg() ? null : (
                                    <React.Fragment>
                                        <div className="msg-generic msg-small margin-top-xs">
                                            <RenderIcons iconName="info-circle" /> {tLang("manageAccount.protectionPlan.noActivePlan.youCurrentlyHave")}{" "}
                                            {tLang("manageAccount.protectionPlan.purchaseAplan")}
                                        </div>
                                        <div className="space-divider margin-top-xs" />
                                    </React.Fragment>
                                )}

                                {protectionPlanSelector.protectionPlanData?.packageList?.length !== 0 && (
                                    <div className="box-content">
                                        <div id="plan-table-container" className="table-container scroll">
                                            {protectionPlanSelector?.protectionPlanData?.packageList?.length! > 1 && (
                                                <React.Fragment>
                                                    <div id="table-nav-left">
                                                        <button
                                                            type="button"
                                                            className="btn-default btn-icon-only"
                                                            title="Previous Plan"
                                                            id="btn-prev-plan"
                                                            disabled={isFirstPlan}
                                                            onClick={() => showPrevPlan()}
                                                        >
                                                            <span className="btn-icon">
                                                                <em className="las la-arrow-left"></em>
                                                            </span>
                                                            <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.previousPlan")}</span>
                                                        </button>
                                                    </div>
                                                    <div id="table-nav-right">
                                                        <button
                                                            type="button"
                                                            className="btn-default btn-icon-only"
                                                            title="Next Plan"
                                                            id="btn-next-plan"
                                                            onClick={() => showNextPlan()}
                                                        >
                                                            <span className="btn-icon">
                                                                <em className="las la-arrow-right"></em>
                                                            </span>
                                                            <span className="btn-text">{tLang("manageAccount.protectionPlan.btn.nextPlan")}</span>
                                                        </button>
                                                    </div>
                                                </React.Fragment>
                                            )}

                                            <table id="protection-table" className="show-plan-1">
                                                <caption className="sr-only">{tLang("manageAccount.protectionPlan.message.tableSelectedNAvailablePlans")}</caption>
                                                <thead>
                                                    <React.Fragment>
                                                        <tr>
                                                            {renderSpacer()}
                                                            {renderPackageHeaderRow("title")}
                                                        </tr>
                                                        {showRow("price") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("price")}
                                                            </tr>
                                                        )}
                                                        {showRow("cta") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("cta")}
                                                            </tr>
                                                        )}
                                                        {showRow("remaining-days") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("remaining-days")}
                                                            </tr>
                                                        )}
                                                        {showRow("billing") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("billing")}
                                                            </tr>
                                                        )}
                                                        {showRow("savings") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("savings")}
                                                            </tr>
                                                        )}
                                                        {showRow("providedBy") && (
                                                            <tr>
                                                                {renderSpacer()}
                                                                {renderPackageHeaderRow("providedBy")}
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                </thead>
                                                <tbody>
                                                    {protectionPlanSelector.protectionPlanData?.productList &&
                                                        protectionPlanSelector.protectionPlanData.productList.map((productDetail, index: number) =>
                                                            productDetail.displayName !== "Cyber Claim Support" ? (
                                                                <tr key={"productlist_" + productDetail.rowId}>
                                                                    <th className="row-label" scope="row">
                                                                        <div className="drawer-container">
                                                                            <div className="drawer-header">
                                                                                <button
                                                                                    aria-expanded="false"
                                                                                    className="btn-default btn-toggle btn-table-drawer"
                                                                                    id={"btn-feature-" + index}
                                                                                    onClick={() => {
                                                                                        toggle("feature-" + index, "btn-feature-" + index);
                                                                                    }}
                                                                                >
                                                                                    <span className="btn-toggle-status sr-only">
                                                                                        {tLang("manageAccount.protectionPlan.btn.show")}
                                                                                    </span>
                                                                                    <span
                                                                                        className={
                                                                                            productDetail.description == null ||
                                                                                                productDetail.description.length === 0
                                                                                                ? ""
                                                                                                : "btn-text"
                                                                                        }
                                                                                    >
                                                                                        {productDetail.displayName}
                                                                                    </span>
                                                                                </button>
                                                                            </div>
                                                                            <div className="drawer-content" id={"feature-" + index} style={{ display: "none" }}>
                                                                                <h3 className="sr-only">{productDetail.displayName}</h3>
                                                                                {showProductDetail(productDetail.description as string)}
                                                                            </div>
                                                                        </div>
                                                                    </th>
                                                                    {protectionPlanSelector.protectionPlanData.packageList &&
                                                                        protectionPlanSelector.protectionPlanData.packageList.map((pkg, pkgIndex: number) => (
                                                                            <React.Fragment key={"pkg_product_" + pkgIndex}>
                                                                                <td className="row-cell">
                                                                                    {pkg != null && pkg.Products != null && (
                                                                                        <React.Fragment>
                                                                                            {displayProduct(pkg.IsActive, pkg.Products[index])}

                                                                                            {pkg.Products[index].isAddOnService && (
                                                                                                <React.Fragment>
                                                                                                    <br />(
                                                                                                    {tLang("manageAccount.protectionPlan.complimentaryAddon")})
                                                                                                </React.Fragment>
                                                                                            )}
                                                                                        </React.Fragment>
                                                                                    )}
                                                                                </td>
                                                                            </React.Fragment>
                                                                        ))}
                                                                </tr>
                                                            ) : (
                                                                ""
                                                            )
                                                        )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>

            <ErrorBoundary componentName="Protection Plan Dialog Container" type="showError" replaceDefaultContent={false} errorMsg="">
                {confirmationDialog && (
                    <EZSProtectionPlanDialogContainer
                        initialDialog={initialDialog}
                        packageIndex={packageIndex}
                        onClose={closeProtectionPlanDialog}
                        subscriptionTypeChange={subscriptionTypeChange}
                        isUserHaveTrial={isUserHaveTrial}
                        isPackageActive={changePackageIsActive}
                        isBfsCancelFlow={showCancelForBfsPartner}
                    ></EZSProtectionPlanDialogContainer>
                )}
            </ErrorBoundary>
        </React.Fragment>
    );
};

export default EZSProtectionPlan;
